import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=36887dec&scoped=true"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceCard.vue?vue&type=style&index=0&id=36887dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36887dec",
  null
  
)

export default component.exports